<div class="can" data-test="cashea-announcement">
    <button type="button" class="can__close" aria-label="Cerrar" (click)="dismiss('close_button')" data-test="cashea-announcement-close">
        <fa-icon [icon]="['fas', 'times']"></fa-icon>
    </button>

    <section class="can__hero">
        <span class="can__glow can__glow--violet" aria-hidden="true"></span>
        <span class="can__glow can__glow--yellow" aria-hidden="true"></span>

        <div class="can__logos">
            <img src="assets/icons/logo.png" alt="Fina" class="can__logo can__logo--fina" />
            <span class="can__logos-x" aria-hidden="true">×</span>
            <img src="assets/icons/logo_cashea.png" alt="Cashea" class="can__logo can__logo--cashea" />
        </div>

        <span class="can__badge">¡Nuevo!</span>
        <h2 class="can__title" id="can-title">{{ title }}</h2>
        <p class="can__subtitle">{{ subtitle }}</p>
    </section>

    <section class="can__body">
        <ul class="can__benefits">
            <li class="can__benefit" [class.can__benefit--owned]="isLink">
                <span class="can__benefit-icon"><fa-icon [icon]="['fas', 'qrcode']"></fa-icon></span>
                <div class="can__benefit-text">
                    <strong>
                        Cashea QR
                        <span class="can__tag can__tag--owned" *ngIf="isLink"><fa-icon [icon]="['fas', 'check']"></fa-icon> Ya lo tienes</span>
                    </strong>
                    <span>El cliente escanea en la tienda y paga su inicial desde la app.</span>
                </div>
            </li>
            <li class="can__benefit can__benefit--highlight">
                <span class="can__corner-badge">{{ isLink ? '¡Nuevo para ti!' : '¡Nuevo!' }}</span>
                <span class="can__benefit-icon"><fa-icon [icon]="['fas', 'link']"></fa-icon></span>
                <div class="can__benefit-text">
                    <strong> Cashea Link </strong>
                    <span>Envías un link por WhatsApp y tu cliente compra desde donde esté.</span>
                </div>
            </li>
            <li class="can__benefit">
                <span class="can__benefit-icon"><fa-icon [icon]="['fas', 'bolt']"></fa-icon></span>
                <div class="can__benefit-text">
                    <strong>Todo cuadra en Fina</strong>
                    <span>Las cuotas y los pagos de Cashea se registran solos en tus cuentas.</span>
                </div>
            </li>
        </ul>

        <p class="can__note" *ngIf="!canRequest">Pídele al dueño o al administrador del comercio que lo active desde <strong>Cuentas › Cuentas por cobrar › Cashea</strong>.</p>

        <div class="can__actions">
            <button type="button" class="btn btn-link can__later" *ngIf="canRequest" (click)="dismiss('later')" data-test="cashea-announcement-later">Ahora no</button>
            <button type="button" class="btn can__cta" (click)="primary()" data-test="cashea-announcement-cta">
                {{ canRequest ? ctaLabel : 'Entendido' }}
            </button>
        </div>
    </section>
</div>
